export default "__VITE_ASSET__DR7Dx59___"